/* eslint-disable @typescript-eslint/no-unused-vars */

export default function generateMocks(baseUrl?: string) {

  return [
  ];
}
